// extracted by mini-css-extract-plugin
module.exports = {"manage-skill-tags":"hS9X6","manage-skill-tags_one-line-text":"_3A9zv","manage-skill-tags_panel-wrapper":"_6yLsT","status-icon":"qYasf"};